export default {
  /**
   * How many pixels the users mouse should move before
   * showing the interface elements like the navigation
   */
  movementThresholdBeforeShowingInterface: 40,

  /**
   * How long to show the loader at a minimum. We could for example
   * load a video in the background, but even if that loads in say
   * 1 second, we still want to show the loader a little longer.
   */
  minimumLoaderTimeout: 4,

  /**
   * How long to show the loader at a maximum. If for example we're
   * a loading a video in the background, but it doesn't load for some
   * reason. We still want to hide the loader after set seconds.
   */
  maximumLoaderTimeout: 6,
};
